<app-aggregated-amount-item
  name="uDiscover ページビュー"
  icon="./assets/udiscover.png"
  amount="{{ (udiscoverPageviewModel$ | async)?.units }}"
  unit="ページビュー数"
  [rate]="(udiscoverPageviewModel$ | async)?.rate"
  help="{{ (selectedArtist$ | async).nameMain }} の uDiscover ページビュー数です。{{
    ((selectedArtist$ | async)?.udiscover.keywords).join(',')
  }} を含むページの選択期間内の合計ページビュー数です。"
  [hasAmount]="(udiscoverPageviewModel$ | async)?.hasUnits"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
></app-aggregated-amount-item>
